import { useGlobalStore } from '../store'

const useExportToCsvObjects = () => {
  const { exportToCsvObject, setExportToCsvObject } = useGlobalStore()
  const updatingExportToCsvObject = (obj , isOverride = false) => {
    const key = Object.keys(obj)[0]
    if (!exportToCsvObject?.[key] || isOverride) {
      // localStorage.setItem(key, JSON.stringify(obj[key]))
      setExportToCsvObject({...exportToCsvObject, ...obj})
      // setExportToCsvObject({ ...obj })
    }
  }
  return { updatingExportToCsvObject }
}

export { useExportToCsvObjects }
